import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';

export type TEventInitialState = {
  discountRate: number;
  discountConstant: number;
};

const initialState: Partial<TEventInitialState> = {
  discountRate: 0,
  discountConstant: 0,
};

export const eventSelector = (state: RootState) => state.event;

export const popupSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setEvent: (state, action) => {
      state = {
        ...action.payload,
      };
      return state;
    },
  },
});

export const { setEvent } = popupSlice.actions;

export default popupSlice.reducer;
